import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const InvalidDTBIDError = () => {
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.InvalidDtbIdError
  });
};
export default InvalidDTBIDError;